import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

import type { Location } from "../types";

dayjs.extend(isSameOrAfter);

export const matchesSearch = (location: Location, query: string) => {
  const queryLowerCase = query.toLowerCase();
  return (
    location.locationNumber.includes(queryLowerCase) ||
    location.core.locationName.toLowerCase().includes(queryLowerCase) ||
    location.core.physicalAddress.city.toLowerCase().includes(queryLowerCase) ||
    location.core.physicalAddress.state.toLowerCase().includes(queryLowerCase)
  );
};

export const matchesRegions = (location: Location, regions: string[]) =>
  regions.length === 0 ||
  regions.includes(location.fieldOpsHierarchy.regionCode);

export const matchesStates = (location: Location, states: string[]) =>
  states.length === 0 ||
  states.includes(location.core.physicalAddress.state) ||
  (!location.core.physicalAddress.state && states.length === 0);

const filterLocations = (
  locations: Location[],
  query: string,
  regions: string[],
  states: string[],
): Location[] =>
  locations.filter(
    (l) =>
      matchesSearch(l, query) &&
      matchesRegions(l, regions) &&
      matchesStates(l, states),
  );

export default filterLocations;
